<template>
  <BaseStyle :model="model" class="content-base">
    <div
      v-for="targetItem in purchaseItems"
      :key="targetItem.name"
      class="flex px-5 pb-2 pt-6 items-start justify-between border-b"
    >
      <div class="w-9/12" v-text="targetItem.name" />
      <div class="w-3/12 text-right flex-grow">
        {{ targetItem.count }}{{ targetItem.itemUnit }}
      </div>
    </div>
  </BaseStyle>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { useInsertDataStore } from '@/hooks/use_insert_data_store';
import { ContentPurchaseCountConfirmModel } from '@/models/content_purchase_count_confirm_model';

import BaseStyle from './BaseStyle.vue';

export default defineComponent({
  name: 'ContentPurchaseCountConfirm',
  components: {
    BaseStyle,
  },
  props: {

    /**
     * Model
     */
    model: {
      type: Object as PropType<ContentPurchaseCountConfirmModel>,
      default: undefined,
    },
  },
  setup() {
    const { purchaseItems } = useInsertDataStore();
    return {
      purchaseItems,
    };
  },
});
</script>
